module.exports = __webpack_public_path__ + "static/media/1020586.9ca630fe.png";